import React, { Component } from 'react'
import Icon from 'components/icon/icon'

import { 
    doClickEventListeners,
    getOffset
} from 'utils'

class MobileSubMenu extends Component {
    state = {
        isOpen: false
    }

    UNSAFE_componentWillMount(){
        doClickEventListeners(this.handleClick)
	}

	componentWillUnmount(){
        doClickEventListeners(this.handleClick, true)
	}

	handleClick = e => {
		if(this.ref && !this.ref.contains(e.target) && this.state.isOpen){
            this.toggleMenu()
		}
	}

    toggleMenu = _ => {
        let distanceFromBottom = null

        if(this.ref){
            const buttonScreenOffset = getOffset(this.ref).top
            const totalHeight = document.body.scrollHeight

            distanceFromBottom = totalHeight - buttonScreenOffset
        }

        if(this.props.setOpenStatus){
            this.props.setOpenStatus(!this.state.isOpen)
        }

        this.setState({
            isOpen: !this.state.isOpen,
            goUp: (distanceFromBottom && distanceFromBottom < 330)
        })
    }

    render(){
        const { 
            options,
            isUp,
            desktopLabel
        } = this.props

        const {
            isOpen,
            goUp
        } = this.state

        const className = `mobile-sub-menu ${!desktopLabel ? 'mobile-only' : '' } ${ isOpen ? 'open' : ''} ${ (goUp || isUp) ? 'up' : ''}`

        const tempOptions = [...options]

        if(goUp){
            tempOptions.reverse()
        }

        return (
            <div 
                ref={e => this.ref = e} 
                className={className}
                onClick={e => e.stopPropagation()}
            >
                <button onClick={this.toggleMenu}>
                    { desktopLabel }
                    <Icon name={`fe-${ desktopLabel ? 'chevron-down' : 'more-vertical' }`} />
                </button>
                <div>
                    <ul>
                    {tempOptions.map((option, index) => {
                        return (
                            <li key={index}>
                                <button disabled={!!option.disabled} onClick={_ => {
                                    if(this.state.isOpen){
                                        this.setState({
                                            isOpen: false
                                        })
                                    
                                        option.callback()
                                    }
                                }}>
                                    <Icon name={option.icon} />
                                    <span>
                                        { option.label }
                                    </span>
                                </button>
                            </li>
                        )
                    })}
                    </ul>
                </div>
            </div>
        )
    }
}

export default MobileSubMenu